import React, { Component } from "react";
import { Input, Form, InputNumber } from "antd";
import styles from "../index.module.less";
import { observer, inject } from "mobx-react";

const FormItem = Form.Item;
const { TextArea } = Input;

@Form.create({
	onFieldsChange(props, changedFields) {
		props.onFieldsChange(changedFields);
	},
	mapPropsToFields(props) {
		return props.fields;
	}
})
@observer
class RankerXIndexerForm extends Component {
	render() {
		return (
			<Form layout="vertical" className={styles.rxform}>
				<FormItem label="Delay (in minutes) between submissions for each account">
					{this.props.form.getFieldDecorator("rankerxIndexerAccountDelay", {
						rules: [
							{
								required: true,
								type: "integer",
								min: 3,
								message: "Must be greater or equal to 3"
							}
						]
					})(<InputNumber min={3} />)}
				</FormItem>
				<FormItem label="Max submissions (smaller than 25) for each account per day">
					{this.props.form.getFieldDecorator(
						"rankerxIndexerDailySubmissionPerAccount",
						{
							rules: [
								{
									required: true,
									type: "integer",
									max: 25,
									message: "Must be smaller or equal to 25"
								}
							]
						}
					)(<InputNumber max={25} />)}
				</FormItem>
				<FormItem label="Max browser threads for RankerX Indexer">
					{this.props.form.getFieldDecorator("maxIndexerThreads", {
						rules: [
							{
								required: true,
								type: "integer",
								message: "Must be a number"
							}
						]
					})(<InputNumber max={25} />)}
				</FormItem>
				<FormItem label="Additional domains to be indexed">
					<span style={{ fontSize: 12 }}>
						By default, RankerX Indexer only submits Premium Sites, if you want
						to index additional sites e.g. your private network sites, you can
						add them here (format is: abc.com)
					</span>
					{this.props.form.getFieldDecorator(
						"additionalSitesToIndexedByRankerXIndexer"
					)(<TextArea />)}
				</FormItem>
			</Form>
		);
	}
}

@inject("rootStore")
@observer
class RankerXIndexTab extends Component {
	onFieldsChange = changedFields => {
		const {
			rootStore: { optionsStore }
		} = this.props;
		optionsStore.formChanged(changedFields);
	};

	mapPropsToFields = () => {
		const {
			rootStore: { optionsStore }
		} = this.props;
		const options = optionsStore.stateForm;

		return {
			rankerxIndexerAccountDelay: Form.createFormField(
				options.rankerxIndexerAccountDelay
			),
			rankerxIndexerDailySubmissionPerAccount: Form.createFormField(
				options.rankerxIndexerDailySubmissionPerAccount
			),
			maxIndexerThreads: Form.createFormField(options.maxIndexerThreads),
			additionalSitesToIndexedByRankerXIndexer: Form.createFormField(
				options.additionalSitesToIndexedByRankerXIndexer
			)
		};
	};

	render() {
		return (
			<span>Due to <b>Google</b> not allowing submitting links to <b>Search Console</b> any more, RankerX Indexer has stopped working. We are in the progress of releasing a new free indexer</span>
		)
		// return (
		// 	<RankerXIndexerForm
		// 		fields={this.mapPropsToFields()}
		// 		onFieldsChange={this.onFieldsChange}
		// 	/>
		// );
	}
}

export default RankerXIndexTab;
